"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var Logger = /** @class */ (function () {
    function Logger() {
        this._levels = {
            NOTSET: 0,
            TRACE: 5,
            DEBUG: 10,
            INFO: 20,
            WARN: 30,
            ERROR: 40,
            CRITICAL: 50,
        };
        this._colorLevels = {
            NOTSET: "",
            TRACE: "color: cyan;",
            DEBUG: "color: blue;",
            INFO: "color: green;",
            WARN: "color: orange;",
            ERROR: "color: red;",
            CRITICAL: "color: white; background-color: red; font-weight: bold; text-decoration: underline;",
        };
        this._originalConsole = {};
        if (console.logLevel === undefined)
            console.logLevel = 0;
        if (!console.history)
            console.history = [];
        this.overrideConsole();
    }
    Logger.prototype._collect = function (type, args) {
        var timestamp = new Date().toUTCString();
        console.history.push({
            type: type,
            timestamp: timestamp,
            arguments: args,
        });
    };
    Logger.prototype.overrideConsole = function () {
        var _this = this;
        var methods = [
            "NOTSET",
            "TRACE",
            "DEBUG",
            "INFO",
            "WARN",
            "ERROR",
            "CRITICAL",
        ];
        methods.forEach(function (method) {
            var key = method.toLowerCase();
            // Save original console method
            var original = console[key];
            if (typeof original === "function") {
                _this._originalConsole[key] = original.bind(console);
            }
            else {
                // fallback: do nothing
                _this._originalConsole[key] = undefined;
            }
            // Override global console
            console[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return _this._intercept(method, args);
            };
        });
        // Aliases
        console.warning = console.warn;
        console.critical = console.critical;
    };
    Logger.prototype._intercept = function (type, args) {
        this._collect(type, args);
        if (console.logLevel <= this._levels[type]) {
            var style = this._colorLevels[type];
            var firstArg = typeof args[0] === "string" && style
                ? __spreadArray(["%c".concat(args[0]), style], __read(args.slice(1)), false) : args;
            var key = type.toLowerCase();
            var methodFn = (this._originalConsole[key] || console.log);
            methodFn.apply(void 0, __spreadArray([], __read(firstArg), false));
        }
    };
    Logger.prototype.restoreConsole = function () {
        Object.entries(this._originalConsole).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], fn = _b[1];
            if (fn)
                console[key.toLowerCase()] = fn;
        });
        console.warning = console.warn;
        console.critical = console.critical;
    };
    // Convenience logging methods (optional)
    Logger.prototype.trace = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._intercept("TRACE", args);
    };
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._intercept("DEBUG", args);
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._intercept("INFO", args);
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._intercept("WARN", args);
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._intercept("ERROR", args);
    };
    Logger.prototype.critical = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._intercept("CRITICAL", args);
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._intercept("NOTSET", args);
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = Logger;
